import * as sentry from "@sentry/react";

const trackTwitterAnalytics = (
  eventCode: string,
  data?: Record<string, unknown>,
) => {
  try {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).twq === "function"
    ) {
      (window as any).twq("event", eventCode, data);
    } else {
      console.warn(`Twitter Pixel is not available. Event: ${eventCode}`);
    }
  } catch (e) {
    console.error(`Error in trackTwitterAnalytics: ${eventCode}`, e);
    sentry.captureException(e);
  }
};

export const twtSignUpEvent = (email: string) => {
  trackTwitterAnalytics("tw-o9c4e-oeufj", { email_address: email });
};

export const twtCardAddedEvent = (email: string) => {
  trackTwitterAnalytics("tw-o9c4e-oeufi", { email_address: email });
};

export default trackTwitterAnalytics;
